import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"width":"75px"}},[_c(VProgressCircular,{staticClass:"my-1",attrs:{"value":_vm.valor,"color":_vm.cor,"size":_vm.tamanho,"width":_vm.largura}},[(_vm.statusProduto !== 'RUPTURA')?_c('span',{staticStyle:{"color":"black"}},[_vm._v("\n      "+_vm._s(_vm.formatarValor(_vm.valor))+"%\n    ")]):_c('span',{staticStyle:{"color":"red"}},[_vm._v("\n      0%\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }